<template>
    <main class="main-content" id="main-content">
        <div class="container">
          <section class="section">
            <page-header>
                <template v-slot:pageTitle>
                  {{$t("booking")}}
                </template>
            </page-header>
            <div class="section__body">
              <div class="reservation box bg-white">
                <form name="reservation-form" method="post">
                  <div class="reservation__title section__title section__title_style3">{{$t("bookingText")}}</div>
                  <div class="reservation__descr section__description color-gray">
                    <p>{{$t("bookingText2", { sum: '3' })}}.</p>
                  </div>
                  <div class="reservation__form">
                    <div class="form-group form-group_date">
                      <div class="form-group__icon svg-icon color-green_light" aria-hidden="true">
                        <svg role="img" width="24" height="24" aria-hidden="true">
                          <use xlink:href="#svg-icon-calendar"></use>
                        </svg>
                      </div>
                      <label class="form-label form-label_hidden" for="start-date">{{$t("bookStart")}}</label>
                      <input class="form-control form-date form-date_start" type="text" name="start-date" id="start-date" size="20" :placeholder='$t(from)' required>
                      <label class="form-label form-label_hidden" for="end-date">{{$t("bookEnd")}}</label>
                      <input class="form-control form-date form-date_end" type="text" name="end-date" id="end-date" size="20" :placeholder='$t(to)' required>
                    </div>
                  </div>
                  <ul class="list list_unstyled reservation__list">
                    <li class="list__item">
                      <!-- ссылки на pdf- или docx-файл--><a class="link" href="javascript: void(0);" download>{{$t("bookMaxValue")}}</a>
                    </li>
                    <li class="list__item">
                      <!-- ссылки на pdf- или docx-файл--><a class="link" href="javascript: void(0);" download>{{$t("bookingFee")}}</a>
                    </li>
                  </ul>
                  <div class="btn-group">
                    <div class="row">
                      <div class="col-12 col-sm-auto">
                        <button class="btn btn_default btn_green js-reservation" type="submit">{{$t("book")}}</button>
                      </div>
                      <div class="col-12 col-sm-auto order-sm-first"><router-link class="btn btn_default btn_white" to="/">{{$t("toMain")}}</router-link></div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
    </main>
</template>
<script>
import PageHeader from "@/components/PageHeader";
// import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
export default {
  components: {
    PageHeader
  }
}
</script>
<style scoped>

</style>